import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { SegmentClassificationMapModel } from "../../models/SegmentClassificationMapModel";
import SegmentClassificationMapService from "../../services/SegmentClassificationMapService";
import SegmentClassificationMapSlice from "../slices/SegmentClassificationMapSlice";
import { RootState } from "../store";

export const Actions = SegmentClassificationMapSlice.actions;

export const fetchSegmentClassificationMap = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(Actions.setIsSegmentClassificationMapsFetching(true));
    const response: SegmentClassificationMapModel[] =
      await SegmentClassificationMapService.getSegmentClassificationMap();
    dispatch(Actions.setSegmentClassificationMap(response));
    dispatch(Actions.setIsSegmentClassificationMapsFetching(false));
  };
};
